import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const NEXT_STATUS = {
  new: "accepted",
  accepted: "processing",
  processing: "shipped",
  shipped: "delivered",
};
const LABELS = {
  new: "Accept",
  accepted: "Start Processing",
  processing: "Mark Shipped",
  shipped: "Mark Delivered",
};

export default function VendorOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/vendor/orders");
      setOrders(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const advance = async (oid, itemId, status) => {
    try {
      await api.patch(`/vendor/orders/${oid}/items/${itemId}`, { status });
      toast.success("Status updated");
      load();
    } catch { toast.error("Update failed"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Fulfillment</div>
      <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">Incoming Orders</h1>

      {loading ? (
        <div className="mt-8 text-center text-[#3B5249]">Loading…</div>
      ) : orders.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#E2E8E5] bg-white p-12 text-center" data-testid="no-orders">
          <p className="text-[#3B5249]">No orders yet. When customers order your products, they'll appear here.</p>
        </div>
      ) : (
        <div className="mt-8 space-y-4" data-testid="vendor-orders-list">
          {orders.map((o) => (
            <div key={o.id} className="rounded-xl border border-[#E2E8E5] bg-white p-5" data-testid={`vo-${o.id}`}>
              <div className="flex flex-wrap justify-between gap-3 pb-3 border-b border-[#E2E8E5]">
                <div>
                  <div className="text-xs text-[#6E877C]">Order</div>
                  <div className="font-mono text-sm text-[#0F3D2E]">#{o.id.slice(-8).toUpperCase()}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Buyer</div>
                  <div className="text-sm text-[#0F3D2E]">{o.buyer_name}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Ship to</div>
                  <div className="text-sm text-[#0F3D2E]">{o.address?.city}, {o.address?.state} - {o.address?.pincode}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Payment</div>
                  <div className="text-sm text-[#0F3D2E] capitalize">{o.payment_method?.replace("_"," ")}</div>
                </div>
              </div>
              <div className="mt-3 space-y-3">
                {o.items.map((it) => (
                  <div key={it.item_id} className="flex flex-wrap items-center gap-3 text-sm">
                    <img src={it.image} alt="" className="w-14 h-14 rounded object-cover" />
                    <div className="flex-1 min-w-[200px]">
                      <div className="text-[#0F3D2E] font-medium">{it.title}</div>
                      <div className="text-xs text-[#6E877C]">Qty {it.qty} · ₹{(it.price*it.qty).toLocaleString()} · commission ₹{it.commission}</div>
                      {it.awb && (
                        <div className="mt-1 text-xs text-[#14A085]">
                          AWB: <span className="font-mono">{it.awb}</span> · {it.carrier}
                        </div>
                      )}
                    </div>
                    <span className="text-xs px-2 py-1 rounded-full bg-[#E8F5F2] text-[#0F3D2E] capitalize" data-testid={`item-status-${it.item_id}`}>{it.status}</span>
                    {NEXT_STATUS[it.status] && (
                      <button onClick={() => advance(o.id, it.item_id, NEXT_STATUS[it.status])} className="text-sm px-3 py-1.5 rounded-full bg-[#0F3D2E] hover:bg-[#14A085] text-white" data-testid={`advance-${it.item_id}`}>
                        {LABELS[it.status]}
                      </button>
                    )}
                    {it.status !== "delivered" && it.status !== "cancelled" && (
                      <button onClick={() => advance(o.id, it.item_id, "cancelled")} className="text-sm px-3 py-1.5 rounded-full border border-red-300 text-red-600 hover:bg-red-50">
                        Cancel
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
